import React, { useMemo } from 'react';
import { useApi } from '@axiom/ui';
import type { Candidate, OpportunityCandidate } from '@axiom/validation';

import ActivityLog from '../ActivityLog/ActivityLog';
import { TalentActivitiesApi } from '../../api/talent-activities-api';

export type TalentProfileActivityLogProps = {
  name?: string;
  candidate: Candidate;
  opportunities: OpportunityCandidate[];
};

export const TalentProfileActivityLog = ({
  candidate,
  opportunities,
}: TalentProfileActivityLogProps) => {
  const [{ data: activities }] = useApi(
    TalentActivitiesApi.readActivities(candidate.id)
  );

  const eventsData = useMemo(
    () => ({
      events: activities,
      eventSubject: 'Candidate',
      eventSubjectId: candidate.id,
    }),
    [activities, candidate.id]
  );

  return (
    <ActivityLog
      eventsData={eventsData}
      opportunities={opportunities}
      candidateDisplayName={candidate.calculatedDisplayName}
    />
  );
};
